import React from 'react';
import Home from './components/Home/Home';

const App = () => {
  return (
    <Home></Home>
  );
}

export default App;
